/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Salutation1Inputs */

const en_formfields_salutation1 = /** @type {(inputs: Formfields_Salutation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salutation`)
};

/**
* | output |
* | --- |
* | "Salutation" |
*
* @param {Formfields_Salutation1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_salutation1 = /** @type {((inputs?: Formfields_Salutation1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Salutation1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_salutation1(inputs)
});
export { formfields_salutation1 as "formFields_salutation" }